import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { requestHandler } from '../utils/requestHandler';
import {
  LOGOUT_ENDPOINT,
  LOGOUT_CONTEXT,
  X_SYF_ID_TOKEN,
  X_SYF_MERCHANT_ID,
} from '../utils/constants/apiConstants';
import {
  SESSION_ID_SESSION_STORAGE_KEY,
  CLIENT_ID_SESSION_STORAGE_KEY,
} from '../utils/constants/sessionStorageConstants';
import { mockLogout } from '../mocks/mockLogoutResponse';
import { isMock, setErrorInAppState } from '../utils/helpers';
import {
  AppState,
  LogoutSlice,
  LogoutSuccessResponse,
  ApiEndPointErrorResponse,
} from '../interfaces/store.interface';

export const logout = 'logout';
const initialState: LogoutSlice = {
  logoutApiResponse: {},
};

export const executeLogout = createAsyncThunk(
  `${logout}/executeLogout`,
  async (_arg, { getState }) => {
    const state: any = getState();
    const transmitToken = state.customerVerificationForm.transmitToken;
    const clientId = sessionStorage.getItem(CLIENT_ID_SESSION_STORAGE_KEY);
    const requestHeaders = {
      customHeaders: {
        [X_SYF_ID_TOKEN]: transmitToken,
        [X_SYF_MERCHANT_ID]: clientId,
      },
    };
    const sessionId = sessionStorage.getItem(SESSION_ID_SESSION_STORAGE_KEY);
    try {
      if (isMock()) {
        return mockLogout;
      } else {
        const axiosInstance = requestHandler({
          ...requestHeaders,
        });
        const { data }: any = await axiosInstance.put(
          `${LOGOUT_ENDPOINT}/${sessionId}`,
        );
        return data as LogoutSuccessResponse;
      }
    } catch (error: any) {
      const errorObject = error?.response || error;
      setErrorInAppState(errorObject, LOGOUT_CONTEXT);
      return error as ApiEndPointErrorResponse;
    }
  },
);

export const logoutSlice = createSlice({
  name: logout,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(executeLogout.pending, (state) => {
      state.logoutApiResponse = {};
    });
    builder.addCase(executeLogout.fulfilled, (state, { payload }: any) => {
      state.logoutApiResponse = payload;
    });
    builder.addCase(executeLogout.rejected, (state, { payload }: any) => {
      state.logoutApiResponse = payload;
    });
  },
});

export default logoutSlice.reducer;

export const getLogout = (state: AppState) => state.logout.logoutApiResponse;
export const isLogoutSuccessfully = (state: AppState) =>
  state.logout?.logoutApiResponse?.code === '1001';
